import React from 'react';
import { CheckIcon, CrownIcon, FileTextIcon, LockIcon, ZapIcon } from 'lucide-react';
import { DOWNLOADS, MOCKUP_ALT, MOCKUP_IMAGE, PRICE } from '../data/content';
import { subjects } from '../data/tramos';
import { Accordion } from './Accordion';
import { Countdown } from './Countdown';
import { CtaButton } from './CtaButton';
import { SampleLink } from './SampleLink';
import { ViewerCounter } from './ViewerCounter';
type PriceSectionProps = {
  onBuy: () => void;
};
const includes = ['32 Tomos completos', '24 Bonos Premium', 'Más de 1.600 actividades listas para usar', 'Negocio llave en mano para empezar desde el primer día'];
const trustItems = [{
  icon: FileTextIcon,
  label: '100% PDF'
}, {
  icon: LockIcon,
  label: 'Pago seguro'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}];
export function PriceSection({
  onBuy
}: PriceSectionProps) {
  return <section id="precio" className="bg-cream px-5 py-10 sm:px-8 lg:py-14" data-id="element-76" data-mp="kqowf6x7aw0q">
      <div className="mx-auto w-full max-w-[520px]" data-id="element-77" data-mp="krgdzdtyqt80">
        <ViewerCounter data-id="element-78" data-mp="1micjzs3s3ocn" />
        <div className="relative mt-9 rounded-3xl border-2 border-coral bg-white px-5 pb-7 pt-9 shadow-soft sm:px-7" data-id="element-79" data-mp="1mhucfzbo1npf">
          <p className="absolute -top-4 left-1/2 flex -translate-x-1/2 items-center gap-2 whitespace-nowrap rounded-full bg-coral px-5 py-2 font-sans text-[12px] font-bold uppercase tracking-[0.08em] text-white shadow-soft sm:text-[13px]" data-id="element-80" data-mp="1rj06q1kz5j12">
            <CrownIcon aria-hidden="true" className="h-4 w-4" strokeWidth={2.2} data-id="element-81" data-mp="258lkmxjx3828" />
            Opción más recomendada
          </p>
        <div className="flex w-full items-center justify-center" data-id="element-82" data-mp="2a75ava5jn60e">
          <img src={MOCKUP_IMAGE} alt={MOCKUP_ALT} loading="lazy" decoding="async" sizes="(min-width: 640px) 420px, 88vw" width={1240} height={1240} className="w-full max-w-[420px]" data-id="element-83" data-mp="1wh1pelehngc0" />
        </div>
        <div className="mt-8" data-id="element-84" data-mp="2o87uzhcza68o">
          <span className="animate-badge-pulse inline-flex items-center gap-1.5 rounded-full bg-butter px-4 py-1.5 font-sans text-[14px] font-bold text-ink" data-id="element-85" data-mp="2o6wqffbpkugi">
            +{DOWNLOADS} descargas 🚀
          </span>
          <h2 className="mt-4 font-display text-[32px] font-semibold uppercase leading-[1.1] text-ink sm:text-[38px]" data-id="element-86" data-mp="32u4yi79q0jo9">
            Megapack Aula de Éxitos Business
          </h2>
          <p className="mt-2 font-sans text-[17px] font-bold leading-snug text-ink-soft" data-id="element-87" data-mp="2tsxd2psazdbl">
            Todos los tramos + Emprendimiento Listo
          </p>
          <div className="mt-4 flex items-baseline gap-3" data-id="element-88" data-mp="2ox9pufxdsu8q">
            <p className="font-display text-[52px] font-semibold leading-none text-coral sm:text-[58px]" data-id="element-89" data-mp="2jxdic6ph6kof">
              {PRICE.current}
            </p>
            <p className="font-sans text-[18px] text-muted line-through" data-id="element-90" data-mp="2b38wk1p77zfr">
              {PRICE.original}
            </p>
          </div>
          <span className="animate-badge-pulse mt-4 inline-flex items-center gap-1.5 rounded-full bg-urgent px-4 py-2 font-sans text-[13px] font-bold uppercase tracking-[0.04em] text-white" data-id="element-91" data-mp="265p7e6qyq291">
            Única oportunidad · solo por hoy! 🔥
          </span>
        </div>
        <div className="mt-8" data-id="element-92" data-mp="1m2t0tbidbdw9">
          <CtaButton label="Agregar al carrito" onClick={onBuy} data-id="element-93" data-mp="1m1hylg4kme79" />
        </div>
        <div className="mt-3" data-id="element-94" data-mp="1r0l22w4wkcd4">
          <SampleLink data-id="element-95" data-mp="1qzt79nj4qinw" />
        </div>
        <Countdown data-id="element-96" data-mp="1w0h78ypc69u9" />
        <ul className="mt-4 flex flex-wrap items-center justify-center gap-x-5 gap-y-2" data-id="element-97" data-mp="1vzxs1pr2lzjx">
          {trustItems.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center gap-1.5 font-sans text-[13px] text-ink-soft" data-id="element-98" data-mp="20x7m5ipemze3">
              <Icon aria-hidden="true" className="h-4 w-4 text-muted" data-id="element-99" data-mp="18awbtgbzxk43" />
              {label}
            </li>)}
        </ul>
        <div className="mt-5" data-id="element-100" data-mp="1d9g0hohz5a05">
          <Accordion id="megapack-incluye" className="bg-cream" openClassName="bg-cream" header={<span className="animate-attention font-sans text-[15px] font-bold uppercase tracking-[0.06em] text-coral" data-id="element-102" data-mp="1i1ra5j2ioa5w">
                Ver qué incluye
              </span>} data-id="element-101" data-mp="1d97nzxprk6ph">
            <p className="font-sans text-[15px] leading-relaxed text-ink-soft" data-id="element-103" data-mp="pk540j7nq1rt">
              Todo el contenido que necesitás para Primaria en Uruguay,
              organizado por Tramos y Áreas, junto con un sistema probado para
              comenzar tu propio negocio educativo.
            </p>
            <ul className="mt-5 space-y-2.5" data-id="element-104" data-mp="30z44jszmumnv">
              {includes.map((item, i) => <li key={item} data-id="element-105" data-mp="31172r0axvm3o" data-mpi={i}>
                  <span className="flex items-start gap-3" data-id="element-106" data-mp="2w85lwmr69chg">
                    <CheckIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-[#4B7A58]" strokeWidth={2.5} data-id="element-107" data-mp="2w6ufef6cdqmn" />
                    <span className="font-sans text-[15px] font-bold leading-relaxed text-ink" data-id="element-108" data-mp="35yqpyppm797r">
                      {item}
                    </span>
                  </span>
                  {i === 0 && <ul className="ml-7 mt-2.5 grid gap-2 sm:grid-cols-2" data-id="element-109" data-mp="3ez5edxxvl4fh">
                      {subjects.map(subject => <li key={subject} className="rounded-xl bg-white px-3.5 py-2 font-sans text-[14px] text-ink" data-id="element-110" data-mp="1pk7au5si79a6">
                          {subject}
                        </li>)}
                    </ul>}
                </li>)}
            </ul>
          </Accordion>
        </div>
        </div>
      </div>
    </section>;
}